// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "錯誤代碼：",
    "error.search": "請搜尋我們的知識庫以了解詳情",
    dismiss: "離開",
    "installation.title": "",
    "cancelation.button": "取消",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "初始化失敗",
      description: "我們無法轉譯頁面。請聯絡支援服務。",
    },
    "EOS-UI-UE": {
      title: "發生錯誤。",
      description: "發生錯誤。請聯絡支援服務。",
    },
    "EOS-IN-BC": {
      title: "安裝失敗",
      description: "我們無法顯示安裝程序。請聯絡支援服務。",
    },
    "EOS-IN-UE": {
      title: "安裝失敗",
      description: "發生錯誤。請聯絡支援服務。",
    },
    "EOS-IN-FF": {
      title: "安裝失敗",
      description: "我們無法連線到 Epic Online Services。請聯絡支援服務。",
    },
    "EOS-IN-FF-*": {
      title: "安裝失敗",
      description: "我們無法對 Epic Online Services 執行請求。請聯絡支援服務。",
    },
    fallback: {
      title: "發生錯誤。",
      description: "發生錯誤。請聯絡支援服務。",
    },
  },
};
